<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <!-- Primeira linha: Unidade Administrativa -->
                    <b-col lg="8" sm="12" class="ml-2">
                        <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                            @onselect="handleSelectUnidadeAdministrativa" v-model="form.departamento"
                            :label="'Unidade Administrativa:'" invalidFeedback="Informe uma unidade administrativa!" />
                    </b-col>
                    <b-col lg="3" sm="12"></b-col>

                    <!-- Segunda linha: Gestor -->
                    <b-col lg="8" sm="12" class="ml-2">
                        <lg-finder-page-pessoa id="finderResponsavelTarefa" label="Gestor:"
                            @onselect="handleSelectResponsavelTarefa" v-model="form.responsavel"
                            invalidFeedback="Informe um responsável!" :title="'Responsáveis'" />
                    </b-col>
                    <b-col lg="3" sm="12"></b-col>

                    <!-- Terceira linha: Datas + Botões de ação à direita -->
                    <b-col lg="3" md="4" sm="6" class="mt-2">
                        <lg-form-date invalidFeedback=" " description="" v-model="form.dataDe" label="De:" />
                    </b-col>
                    <b-col lg="3" md="4" sm="6" class="mt-2">
                        <lg-form-date invalidFeedback=" " description="" v-model="form.dataAte" label="Até:" />
                    </b-col>
                    <b-col lg="6" md="4" sm="12" class="text-right mt-2">
                        <b-button id="localizarHistoricoCarga" class="my-2" size="sm" style="height: 32px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarHistoricoCarga" title="Localizar"></b-tooltip>
                        </b-button>
                        <b-button v-if="temPrivilegioInclusao()" id="novoHistorico" class="ml-2 mr-2 my-2"
                            style="height: 32px" size="sm" pill variant="secondary" @click="save">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novoHistorico" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                        <b-button id="limparHistoricoCarga" class="my-2" size="sm" style="height: 32px" pill
                            variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limparHistoricoCarga" title="Limpar"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>


                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>

                    <template v-slot:cell(relatorio)="row">
                        <div :id="'relatorioPdf-' + row.item.id">
                            <img @click="gerarRelatorio(row.item.id)" :src="pdf" class="img img--clickable" alt="PDF" />
                            <b-tooltip :target="'relatorioPdf-' + row.item.id"
                                title="Relatório de IBP - Carga Patrimonial..."></b-tooltip>

                        </div>
                    </template>


                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>


                    <template v-slot:cell(editar)="row">
                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button-carga'" class="my-2"
                            size="sm" pill variant="primary" @click="editar(row.item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="row.index + 'edit-button-carga'" title="Editar..."></b-tooltip>
                        </b-button>
                    </template>



                    <template v-slot:cell(visualizar)="row">
                        <b-button :id="row.index + 'visualizar-button-carga'" class="my-2" size="sm" pill
                            variant="primary" @click="visualizar(row.item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="row.index + 'visualizar-button-carga'"
                                title="Visualizar..."></b-tooltip>
                        </b-button>
                    </template>

                    <template v-slot:cell(excluir)="row">
                        <b-button :disabled="!temPrivilegioExclusao()" :id="row.index + 'excluir-carga'" class="my-2"
                            size="sm" pill variant="primary" @click="remove(row.item)">
                            <b-icon icon="trash-fill" />
                            <b-tooltip :target="row.index + 'excluir-carga'" title="Remover..."></b-tooltip>
                        </b-button>
                    </template>



                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <HistoricoCargaPatrimonialEditar @close="fecharModal" :prefix="prefix + title + ' > '" :id="id"
            v-if="showModal">
        </HistoricoCargaPatrimonialEditar>
        <HistoricoCargaPatrimonialItensList @close="fecharModal" :prefix="prefix + title + ' > '"
            v-if="mostrarDetallhes" :id="id"></HistoricoCargaPatrimonialItensList>
    </b-card>
</template>

<script>
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
import PdfIcon from "@/core/assets/icons/pdf.png";

import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import moment from "moment";
import Swal from "sweetalert2";
import HistoricoCargaPatrimonialEditar from "./HistoricoCargaPatrimonialEditar.vue";
import HistoricoCargaPatrimonialItensList from "./HistoricoCargaPatrimonialItensList.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
    components: {
        LgFinderPageUnidadeAdministrativa,
        HistoricoCargaPatrimonialItensList,
        LgFinderPagePessoa,
        LgFormDate,
        HistoricoCargaPatrimonialEditar,
    },

    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        prefix: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            pdf: PdfIcon,

            title: 'Histórico Carga Patrimonial',
            showModal: false,
            id: null,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            mostrarDetallhes: false,
            form: {
                responsavel: {},
                departamento: {},
                dataDe: "",
                dataAte: "",

            },
        };
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/historicocarga`);
        this.load();

    },

    watch: {
        page() {
            this.load();
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "data",
                    label: "Data da carga",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },

                { key: "nomeResponsavel", label: "Gestor da UA na data" },

                { key: "observacao", label: "Observação" },

                { key: "total", label: "Total de IBPs" },
                { key: "visualizar", label: " ", tdClass: "w-1" },
                { key: "editar", label: " ", tdClass: "w-1" },
                { key: "excluir", label: " ", tdClass: "w-1" },
                {
                    key: "relatorio",
                    label: " ",
                },

            ];
        },
    },
    methods: {
        async gerarRelatorio(id) {
            this.param = {};
            this.param.id = id

            this.busy = true
            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-historico-carga');
                const { data } = await resource.getWithParams('PDF', this.param);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }


        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.HISTORICO_CARGA_PATRIMONIAL_EDITAR);

        },
        temPrivilegioExclusao() {
            return verificaPrivilegio(PrivilegiosEnum.HISTORICO_CARGA_PATRIMONIAL_EXCLUIR);

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.HISTORICO_CARGA_PATRIMONIAL_INCLUIR);

        },

        fecharModal() {
            this.id = null;
            this.showModal = false;
            this.mostrarDetallhes = false;
        },
        handleSelectResponsavelTarefa(pessoa) {
            this.form.responsavel = pessoa;
            this.load();
        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento;
            this.load();

        },
        async remove(item) {
            await this.$removeResource(item);
        },
        editar(item) {

            this.id = item.id;
            this.showModal = true;

        },
        visualizar(item) {
            this.id = item.id;
            this.mostrarDetallhes = true;

        },
        clearForm() {

            this.form.departamento = {};
            this.form.responsavel = {};
            this.form.dataDe = "";
            this.form.dataAte = "";
            this.load();

        },
        async load() {

            this.filtro = {};

            if (this.form.dataDe) {
                this.filtro.de = new Date(this.form.dataDe).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.dataAte) {
                this.filtro.ate = new Date(this.form.dataAte).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.departamento && this.form.departamento.id) {
                this.filtro.departamento = this.form.departamento.id;
            }

            if (this.form.responsavel && this.form.responsavel.id) {
                this.filtro.responsavel = this.form.responsavel.id;
            }


            this.busy = true

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });
        },


        async save() {

            Swal.fire({
                title: "Confirmação",
                text: "Tem certeza que deseja um Histórico de sua carga patrimonial ?",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(async (result) => {
                if (result.value) {

                    try {
                        var filtro = {};


                        filtro.departamento = this.form.departamento && this.form.departamento.id ? this.form.departamento : JSON.parse(localStorage.getItem("context")).departamento;


                        if (this.form.responsavel && this.form.responsavel.id)
                            filtro.pessoa = this.form.responsavel;

                        await this.$saveResource(filtro, "", false);
                        this.load();
                    } catch (e) {
                        this.$notify({
                            type: "danger",
                            message: "Ocorreu um erro ao salvar o cadastro.",
                        });
                    }

                }
            });

        },

    },
};
</script>
